<div *ngIf="content?.hasError" class="form-alert" id="formAlertId">
  <idp-form-alert
    [showCloseButton]="true"
    [message]="content?.errorMessage"
    (closePopup)="closePopup()"
  ></idp-form-alert>
</div>
<idp-login-header
  [loginHeaderContent]="content.pageContent.pageHeader"
  [machCore]="machCore"
  (triggerClose)="triggerClose.emit()"
></idp-login-header>

<form
  *ngIf="content"
  [formGroup]="recoveryOptionsForm"
  id="recoveryOptionsForm"
  class="recovery-options"
  (ngSubmit)="onSubmit()"
>
  <div class="recovery-options__options">
    <div class="recovery-options__options__email">
      <idp-radio-button
        [checked]="true"
        [id]="'optionEmail'"
        [formControlName]="'options'"
        [value]="content.pageContent.emailText"
        [text]="content.pageContent.emailLabel"
      ></idp-radio-button>
    </div>
    <div class="recovery-options__options__sqa">
      <idp-radio-button
        [id]="'optionSqa'"
        [formControlName]="'options'"
        [value]="content.pageContent.sqaText"
        [text]="content.pageContent.sqaLabel"
      ></idp-radio-button>
    </div>
  </div>

  <div class="recovery-options__submit-btn">
    <idp-button
      [label]="content.pageContent.buttonLabel"
      [size]="'full-width'"
      (notify)="onSubmit()"
      [disabled]="content.disabledActionButton"
      [customClass]="'recoveryOptionsButton'"
    ></idp-button>
  </div>
</form>
